export default __webpack_public_path__ + "static/media/cpExpired.95cb9887.png";